import { render, staticRenderFns } from "./StepForm.vue?vue&type=template&id=bd4b055c&scoped=true"
import script from "./StepForm.vue?vue&type=script&lang=js"
export * from "./StepForm.vue?vue&type=script&lang=js"
import style0 from "./StepForm.vue?vue&type=style&index=0&id=bd4b055c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd4b055c",
  null
  
)

export default component.exports